<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
                <div v-if="$te(`fields.${name}.description`)" class="toggle-description">
                    {{ $t(`fields.${name}.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomSelect
                    :modelValue="modelValue"
                    :inputKey="name"
                    @update:modelValue="onChanged"
                    :options="options"
                    :showLabel="false"
                    :showDescription="false"
                    ref="optionsSort"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';
    import CustomSelect from '@/components/elements/inputs/CustomSelect';

    export default {
        name: "OptionsSort",
        components: {
            ToggleSimple,
            CustomSelect
        },
        props: {
            modelValue: {
                type: String,
                default: 'default'
            },
            defaultVal: {
                type: String,
                default: 'default'
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'prospects_sort',
                toggleOpen: false,
                options: [
                    { value: 'default', text: 'fields.prospects_sort.option_default' },
                    { value: 'company_name-asc', text: 'fields.prospects_sort.option_name_asc' },
                    { value: 'company_name-desc', text: 'fields.prospects_sort.option_name_desc' },
                    { value: 'changed_time-desc', text: 'fields.prospects_sort.option_changed_date_desc' },
                    { value: 'changed_time-asc', text: 'fields.prospects_sort.option_changed_date_asc' },
                    { value: 'inserted_date-desc', text: 'fields.prospects_sort.option_creation_date_desc' },
                    { value: 'inserted_date-asc', text: 'fields.prospects_sort.option_creation_date_asc' },
                    { value: 'last_visit-desc', text: 'fields.prospects_sort.option_last_visit_desc' },
                    { value: 'last_visit-asc', text: 'fields.prospects_sort.option_last_visit_asc' },
                    { value: 'total_visits-desc', text: 'fields.prospects_sort.option_total_visits_desc' },
                    { value: 'total_visits-asc', text: 'fields.prospects_sort.option_total_visits_asc' },
                ],
            };
        },
        computed: {
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.$emit('update:modelValue', this.defaultVal);
            },
            onChanged(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        }
    }
</script>